import { render, staticRenderFns } from "./BookingAlerts.vue?vue&type=template&id=d02d2920"
import script from "./BookingAlerts.vue?vue&type=script&lang=js"
export * from "./BookingAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports